<template>
    <div class="toolbar" id="kt_toolbar">
        <!--begin::Container-->
        <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
            <!--begin::Page title-->
            <div data-kt-swapper="true" data-kt-swapper-mode="prepend"
                 data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
                 class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
                <!--begin::Title-->
                <h1 class="d-flex align-items-center text-dark fw-bolder fs-3 my-1">

                    {{ title }}

                    <!--begin::Separator-->
                    <span v-if="breadcrumb.length > 0" class="h-20px border-gray-200 border-start ms-3 mx-2"></span>
                    <!--end::Separator-->

                    <Breadcrumb :breadcrumb="breadcrumb"/>

                </h1>
                <!--end::Title-->
            </div>
            <!--end::Page title-->

            <!--begin::Actions-->
            <div class="d-flex align-items-center gap-2 gap-lg-3">
                <Link
                    v-for="action in actions"
                    :href="action.link"
                    class="btn btn-sm btn-primary"
                    v-show="action.show"
                >
                    <i class="bi fs-3" :class="action.icon ?? 'bi-plus'"></i>
                    {{ action.title  }}
                </Link>
            </div>
            <!--end::Actions-->

        </div>
        <!--end::Container-->
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import Breadcrumb from "./Breadcrumb";

export default {

    components: {
        Breadcrumb,
        Link
    },

    created() {
        this.init();
    },

    data: _ => ({
        actions: [],
        breadcrumb: [],
        title: 'Título da página',
    }),

    methods: {
        init() {
            this.emitter.on("breadcrumb", breadcrumb => {
                this.breadcrumb = breadcrumb;
            });

            this.emitter.on("title", title => {
                this.title = title;
            });

            /**
             * Action deve ter a estrutura :
             *
             * {
             *     show: true,
             *     title: 'Novo Usuário',
             *     type: button,
             *     link: 'app.patient.create,
             *     color: '#000',
             * }
             */
            this.emitter.on('action', actions => {
                this.actions = Array.isArray(actions) ? actions : [actions];
            });
        }
    }
}
</script>

